(ns renolit-roofing-service.service.notification
  (:require [dev.gethop.session.re-frame.cognito.token :as session.token]
            [re-frame.core :as rf]
            [renolit-roofing-service.data-loading :as data-loading]
            [renolit-roofing-service.util :as util]))

(rf/reg-sub
 ::unread-count
 (fn [db]
   (get-in db [:notifications :unread-count])))

(rf/reg-event-db
 ::set-unread-count
 (fn [db [_ unread-count]]
   (assoc-in db [:notifications :unread-count] unread-count)))

(rf/reg-event-fx
 ::get-notifications-unread-count-success
 (fn [_ [_ on-success-evts {:keys [data-loading-id]} {:keys [unread-count] :as response}]]
   {:fx (cond-> [[:dispatch [::data-loading/stop-loading data-loading-id]]
                 [:dispatch [::set-unread-count unread-count]]]
          on-success-evts
          (into (mapv #(vector :dispatch (conj % response)) on-success-evts)))}))

(rf/reg-event-fx
 ::read-all-user-notifications
 [(rf/inject-cofx ::session.token/session)]
 (fn [{:keys [db session]} [evt-name {:keys [on-success-evts on-failure-evts]}]]
   {:http-xhrio {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
                 :method :put
                 :uri (str (:api-url db) "/api/notifications/read-all")
                 :response-format (util/ajax-transit-response-format)
                 :format (util/ajax-transit-request-format)
                 :on-success [::util/generic-success-with-callback
                              on-success-evts
                              {:data-loading-id evt-name}]
                 :on-failure [::util/generic-error-with-callback
                              on-failure-evts
                              {:data-loading-id evt-name}]}}))

(rf/reg-event-fx
 ::read-notifications
 [(rf/inject-cofx ::session.token/session)]
 (fn [{:keys [db session]} [evt-name ids {:keys [on-success-evts on-failure-evts]}]]
   {:http-xhrio {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
                 :method :put
                 :uri (str (:api-url db) "/api/notifications/read")
                 :params {:ids ids}
                 :response-format (util/ajax-transit-response-format)
                 :format (util/ajax-transit-request-format)
                 :on-success [::util/generic-success-with-callback
                              on-success-evts
                              {:data-loading-id evt-name}]
                 :on-failure [::util/generic-error-with-callback
                              on-failure-evts
                              {:data-loading-id evt-name}]}}))

(rf/reg-event-fx
 ::mark-notification-read
 (fn [{:keys [db]} [_ id]]
   {:db (update-in db [:notifications :list]
                   (fn [notifications]
                     (mapv #(if (= (:id %) id) (assoc % :is-read true) %) notifications)))
    :fx [[:dispatch [::read-notifications [id]
                     {:on-success-evts [[::get-notifications-unread-count]]}]]]}))

(rf/reg-event-fx
 ::delete-notifications
 [(rf/inject-cofx ::session.token/session)]
 (fn [{:keys [db session]} [evt-name notification-ids {:keys [on-success-evts on-failure-evts]}]]
   {:http-xhrio {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
                 :method :delete
                 :params {:ids notification-ids}
                 :uri (str (:api-url db) "/api/notifications")
                 :response-format (util/ajax-transit-response-format)
                 :format (util/ajax-transit-request-format)
                 :on-success [::util/generic-success-with-callback
                              on-success-evts
                              {:data-loading-id evt-name}]
                 :on-failure [::util/generic-error-with-callback
                              on-failure-evts
                              {:data-loading-id evt-name}]}}))

(rf/reg-event-fx
 ::get-notifications-unread-count
 [(rf/inject-cofx ::session.token/session)]
 (fn [{:keys [db session]} [evt-name {:keys [on-success-evts on-failure-evts]}]]
   {:http-xhrio {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
                 :method :get
                 :uri (str (:api-url db) "/api/notifications/unread-count")
                 :response-format (util/ajax-transit-response-format)
                 :format (util/ajax-transit-request-format)
                 :on-success [::get-notifications-unread-count-success
                              on-success-evts
                              {:data-loading-id evt-name}]
                 :on-failure [::util/generic-error-with-callback
                              on-failure-evts
                              {:data-loading-id evt-name}]}}))
